// extracted by mini-css-extract-plugin
export default {"message":"Message_message__p3Vgy","success":"Message_success__3dhAn","error":"Message_error__dl87C"};